var map = {
	"./about.jpg": 8665,
	"./adv1.jpg": 4940,
	"./adv2.jpg": 1387,
	"./adv3.jpg": 9902,
	"./feedback.jpg": 2709,
	"./getintouch.jpg": 750,
	"./logo-pic.png": 8186,
	"./m-product.jpg": 529,
	"./main_banner.jpg": 226,
	"./marketing.jpg": 4410,
	"./marketing_card1.png": 1668,
	"./marketing_card2.png": 3135,
	"./marketing_card3.png": 1590,
	"./marketing_card4.png": 4009,
	"./marketing_card5.png": 7760,
	"./martech.jpg": 8638,
	"./martech_card1.png": 1600,
	"./martech_card2.png": 9931,
	"./martech_card3.png": 5714,
	"./p-about.jpg": 1010,
	"./p-marketing.jpg": 8341,
	"./p-martech.jpg": 9517,
	"./p-product.jpg": 4416,
	"./p-software.jpg": 1602,
	"./p-strategic.jpg": 7407,
	"./privacy.jpg": 9794,
	"./product.jpg": 6687,
	"./product_card1.png": 249,
	"./product_card2.png": 3333,
	"./product_card3.png": 6843,
	"./product_card4.png": 932,
	"./product_card5.png": 2061,
	"./slide1.jpg": 8928,
	"./slide2.jpg": 1919,
	"./slide3.jpg": 5538,
	"./slide4.jpg": 3585,
	"./soft_card1.png": 3710,
	"./soft_card2.png": 5509,
	"./soft_card3.png": 2444,
	"./software.jpg": 3707,
	"./strategic.jpg": 6240,
	"./strategic_card1.png": 1198,
	"./strategic_card2.png": 5205,
	"./strategic_card3.png": 2316,
	"./whoweare.jpg": 642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;